<template>
  <li :class="['aspect-square rounded-lg w-[calc((100%-0.625rem)/2)] md:w-[calc((100%-(0.625rem*3))/4)] lg:w-[calc((100%-(1.5625rem*5))/6)] transition-width', `bg-${background}`]">
    <component :is="content.link ? DynamicLink : 'div'" :link="content.link" class="flex items-center justify-center p-5 w-full h-full">
      <ResponsiveImage :media="content.image" class="w-full h-full object-contain"/>
    </component>
  </li>
</template>

<script lang="ts">
import type {PropType} from 'vue'
import {ResponsiveImage} from '@/components/helpers'
import {DynamicLink} from '@/components/small'

export default {
  name: 'ImageCard',
  components: {ResponsiveImage},
  setup() {
    return {
      DynamicLink
    }
  },
  props: {
    background: {
      type: String as PropType<background>,
      required: true
    },
    content: {
      type: Object as PropType<ImageCard>,
      required: true
    }
  }
}
</script>